import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const ProctorUReview = observer(class ProctorUReview extends React.Component {
  componentWillMount() {
    const { SessionStore, StepInStore } = this.props.store;
    const { examSid, sessionSid } = this.props;

    if(SessionStore.loadingCalls.indexOf('getReviewPayload') < 0 && !StepInStore.formData) {
      StepInStore.getReviewPayload(examSid, sessionSid);
    }
  }

  componentWillUnmount() {
    const { StepInStore } = this.props.store;

    StepInStore.formData = null;
  }

  getLogin() {
    const { StepInStore } = this.props.store;
    const { formData } = StepInStore;

    const formDelay = setInterval(function(){
      const launchForm = document.querySelector('#review-form');

      if(launchForm) {
        clearInterval(formDelay);

        launchForm.method = formData.method;
        launchForm.action = formData.url;

        Object.keys(formData.fields).forEach(field => {
          const inputField = document.createElement('input');
          inputField.name = field;
          inputField.type = 'text';
          inputField.value = formData.fields[field];
          launchForm.appendChild(inputField);
        });

        const button = document.createElement('button');
        button.text = 'Submit';
        launchForm.appendChild(button);

        launchForm.submit();
      }
    }, 100)
  }

  render() {
    const { SessionStore, StepInStore } = this.props.store;

    if(SessionStore.backgroundLoadingCalls.indexOf('getReviewPayload') < 0) {
      if(StepInStore.reviewUrl) {
        return (
          <iframe
            className="review-frame"
            src={StepInStore.reviewUrl}
          ></iframe>
        )
      } else {
        return (
          <div>
            <iframe
              className="review-frame"
              name="review-frame"
            ></iframe>

            <form
              className="meta"
              id="review-form"
              target="review-frame"
            ></form>

            {this.getLogin()}
          </div>
        )
      }
    }

    return null;
  }
})

export default translate('ProctorUReview')(ProctorUReview);



// WEBPACK FOOTER //
// ./src/app/components/Sessions/ProctorUReview.js